import { css } from 'styled-components';
import { TitleProps } from './models';

export const Title = css<TitleProps>(({ theme }) => {
  return css`
    color: ${theme.colors.primaryDeepBlue};
    text-align: center;
    font-size: 25px;
    font-weight: 600;
    line-height: 30px;

    @media screen and ${theme.device.mobileXL} {
      font-size: 30px;
      line-height: 44px;
    }
  `;
});
